function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M25.9925 0C12.2085 0 0.99292 11.2151 0.99292 25C0.99292 38.7843 12.2084 50 25.9925 50C39.7782 50 50.9929 38.7843 50.9929 25C50.9929 11.2151 39.7782 0 25.9925 0ZM41.2515 33.2744C40.8945 33.6307 40.4266 33.8107 39.959 33.8107C39.4906 33.8107 39.0229 33.6307 38.6657 33.2744L25.9925 20.6031L13.3206 33.2744C12.6062 33.9887 11.4469 33.9887 10.7325 33.2744C10.0177 32.5602 10.0177 31.4022 10.7325 30.6879L24.6991 16.7239C25.4144 16.0097 26.5701 16.0097 27.2841 16.7239L41.2506 30.6879C41.9659 31.4022 41.9659 32.5602 41.2515 33.2744Z",
  fill: "#2E2F3F"
});

var SvgChevronUp = function SvgChevronUp(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChevronUp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chevron-up.cbd81add.svg";
export { ForwardRef as ReactComponent };